import { Component, Inject } from '@angular/core';
import { ConnectionsDialogModel } from './connections-dialog.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocViewerStore } from '@store/legacy/doc-viewer.store';
import { map, takeUntil } from 'rxjs';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-doc-viewer-connections-dialog',
    templateUrl: './doc-viewer-connections-dialog.component.html',
    styleUrls: ['./doc-viewer-connections-dialog.component.scss'],
    standalone: false
})
export class DocViewerConnectionsDialogComponent extends BaseComponent {

public title: string = '';
public items: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConnectionsDialogModel,
  private docViewerStore: DocViewerStore) {
    super();
    this.docViewerStore.currentDocument$.pipe(
      map(() => {
        if (data.type === 'to') {
          this.items = this.docViewerStore.documentDataFormGroup.get('toField').value.split(';').filter(email => email.trim() !== '');
          this.title = 'To';
        }
        else if (data.type === 'from') {
          this.items = this.docViewerStore.documentDataFormGroup.get('fromField').value.split(';').filter(email => email.trim() !== '');
          this.title = 'From';
        }
        else if (data.type === 'cc') {
          this.items = this.docViewerStore.documentDataFormGroup.get('cc').value.split(';').filter(email => email.trim() !== '');
          this.title = 'CC';

        }
        else if (data.type === 'bcc') {
          this.items = this.docViewerStore.documentDataFormGroup.get('bcc').value.split(';').filter(email => email.trim() !== '');
          this.title = 'BCC';
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
   }
}
